declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || '';

function track(eventName: string, params?: Record<string, string | number | boolean>) {
  if (typeof window.gtag !== 'function' || !GA_ID) return;
  window.gtag('event', eventName, params);
}

export const trackNavClick = (section: string) =>
  track('nav_click', { section });

export const trackInstagramClick = (location: string) =>
  track('instagram_click', { location });

export const trackFaqOpen = (questionKey: string) =>
  track('faq_open', { question: questionKey });

export const trackSectionView = (section: string) =>
  track('section_view', { section });
